module.exports = __webpack_public_path__ + "img/velopub.fac6d8c5.jpg";